import { useGetLocation } from "@/entities/location";
import { AppLayoutPage } from "@/modules/app-layout/app-layout-page";
import { PageItemContextGate } from "@/modules/page-item-context-gate";
import { useIdParam } from "@/services/router";

import { LocationPageHeader } from "./location-page-header";
import { LocationPageTabs } from "./location-page-tabs";

export const LocationPage = () => {
  const id = useIdParam();
  const { isLoading, location, context, error } = useGetLocation(id);

  return (
    <PageItemContextGate
      model="location"
      itemContext={context}
      queryError={error}
    >
      <LocationPageHeader location={location} loading={isLoading} />
      <AppLayoutPage>
        <LocationPageTabs location={location} loading={isLoading} />
      </AppLayoutPage>
    </PageItemContextGate>
  );
};

export default LocationPage;
